import * as React from 'react';

const CheckCircle24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16.576 9.48a.75.75 0 1 0-1.152-.96L11 13.829l-2.424-2.91a.75.75 0 1 0-1.152.961l3 3.6a.75.75 0 0 0 1.152 0z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 1C5.924 1 1 5.926 1 12c0 6.075 4.924 11 11 11 6.074 0 11-4.925 11-11 0-6.074-4.926-11-11-11M2.5 12a9.5 9.5 0 1 1 9.5 9.5A9.5 9.5 0 0 1 2.5 12"
  }
));
CheckCircle24.Size = 24;
CheckCircle24.Title = "CheckCircle";

export { CheckCircle24 as default };
